// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Timestamp$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as AllocationFilterWrapper from "../../../../allocation-dashboard-home/allocation-filters/AllocationFilterWrapper.bs.js";
import * as TableWithRowHover$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableWithRowHover.bs.js";

function getTableSchema(active_campaign) {
  return {
          hd: TableWithRowHover$Catalyst.Schema.make_props({
                TAG: /* Custom */1,
                _0: (function (param) {
                    return React.createElement("p", undefined, "Campaign Name");
                  })
              }, (function (apr) {
                  return {
                          TAG: /* Custom */5,
                          _0: (function (param) {
                              var match = apr.campaign_status;
                              var tmp;
                              switch (match) {
                                case /* Active */0 :
                                    tmp = React.createElement("label", {
                                          className: "active-icon"
                                        });
                                    break;
                                case /* Scheduled */1 :
                                    tmp = React.createElement("label", {
                                          className: "scheduled-icon"
                                        });
                                    break;
                                case /* PendingForReview */2 :
                                    tmp = null;
                                    break;
                                
                              }
                              var value = apr.name;
                              return React.createElement("div", {
                                          className: "campaign-name-container"
                                        }, tmp, React.createElement("p", undefined, value !== undefined ? value : null));
                            })
                        };
                }), undefined, undefined),
          tl: {
            hd: TableWithRowHover$Catalyst.Schema.make_props({
                  TAG: /* Custom */1,
                  _0: (function (param) {
                      return React.createElement("p", undefined, "Start Date");
                    })
                }, (function (apr) {
                    return {
                            TAG: /* Custom */5,
                            _0: (function (param) {
                                return React.createElement("div", {
                                            className: "campaign-date-icon-container"
                                          }, React.createElement("p", {
                                                className: "campaign-date"
                                              }, Timestamp$Catalyst.toString(apr.effective_from, "DD MMM YYYY, HH:mm")));
                              })
                          };
                  }), undefined, undefined),
            tl: {
              hd: TableWithRowHover$Catalyst.Schema.make_props({
                    TAG: /* Custom */1,
                    _0: (function (param) {
                        return React.createElement("p", undefined, "End Date");
                      })
                  }, (function (apr) {
                      return {
                              TAG: /* Custom */5,
                              _0: (function (param) {
                                  var value = apr.effective_till;
                                  return React.createElement("div", {
                                              className: "campaign-date-icon-container"
                                            }, React.createElement("p", {
                                                  className: "campaign-date"
                                                }, value !== undefined ? Timestamp$Catalyst.toString(Caml_option.valFromOption(value), "DD MMM YYYY, HH:mm") : null));
                                })
                            };
                    }), undefined, undefined),
              tl: {
                hd: TableWithRowHover$Catalyst.Schema.make_props({
                      TAG: /* Custom */1,
                      _0: (function (param) {
                          return React.createElement("div", {
                                      className: "allocation-dashboard-table-header"
                                    }, React.createElement("h4", undefined, "Allocation Radius"), React.createElement("div", undefined, React.createElement("span", undefined, "Auto"), React.createElement("span", undefined, "  -  "), React.createElement("span", undefined, "Manual")));
                        })
                    }, (function (apr) {
                        return {
                                TAG: /* Custom */5,
                                _0: (function (param) {
                                    var match = apr.campaign_status;
                                    return React.createElement("div", {
                                                className: ""
                                              }, React.createElement(AllocationFilterWrapper.make, {
                                                    filter_data: {
                                                      TAG: /* AllocationRadius */0,
                                                      filter_value: {
                                                        left_value: apr.filters.allocation_radius.auto,
                                                        right_value: apr.filters.allocation_radius.manual
                                                      },
                                                      delta_value: match !== 0 ? ({
                                                            left_value: apr.filters.allocation_radius.auto - active_campaign.filters.allocation_radius.auto,
                                                            right_value: apr.filters.allocation_radius.manual - active_campaign.filters.allocation_radius.manual
                                                          }) : undefined
                                                    },
                                                    show_header: false
                                                  }));
                                  })
                              };
                      }), undefined, undefined),
                tl: {
                  hd: TableWithRowHover$Catalyst.Schema.make_props({
                        TAG: /* Custom */1,
                        _0: (function (param) {
                            return React.createElement("div", {
                                        className: "allocation-dashboard-table-header"
                                      }, React.createElement("h4", undefined, "Dry Run Ratio"), React.createElement("div", undefined, React.createElement("span", undefined, "Threshold"), React.createElement("span", undefined, "  -  "), React.createElement("span", undefined, "Ratio")));
                          })
                      }, (function (apr) {
                          return {
                                  TAG: /* Custom */5,
                                  _0: (function (param) {
                                      var match = apr.campaign_status;
                                      return React.createElement("div", {
                                                  className: ""
                                                }, React.createElement(AllocationFilterWrapper.make, {
                                                      filter_data: {
                                                        TAG: /* DryRun */1,
                                                        filter_value: {
                                                          left_value: apr.filters.dry_run.threshold,
                                                          right_value: apr.filters.dry_run.ratio
                                                        },
                                                        delta_value: match !== 0 ? ({
                                                              left_value: apr.filters.dry_run.threshold - active_campaign.filters.dry_run.threshold,
                                                              right_value: apr.filters.dry_run.ratio - active_campaign.filters.dry_run.ratio
                                                            }) : undefined
                                                      },
                                                      show_header: false
                                                    }));
                                    })
                                };
                        }), undefined, undefined),
                  tl: {
                    hd: TableWithRowHover$Catalyst.Schema.make_props({
                          TAG: /* Custom */1,
                          _0: (function (param) {
                              return React.createElement("div", {
                                          className: "allocation-dashboard-table-header"
                                        }, React.createElement("h4", undefined, "Max Dry Run"), React.createElement("div", undefined, React.createElement("span", undefined, "Auto"), React.createElement("span", undefined, "  -  "), React.createElement("span", undefined, "Manual")));
                            })
                        }, (function (apr) {
                            return {
                                    TAG: /* Custom */5,
                                    _0: (function (param) {
                                        var match = apr.campaign_status;
                                        return React.createElement("div", {
                                                    className: ""
                                                  }, React.createElement(AllocationFilterWrapper.make, {
                                                        filter_data: {
                                                          TAG: /* MaxDryRun */2,
                                                          filter_value: {
                                                            left_value: apr.filters.maps_distance.auto,
                                                            right_value: apr.filters.maps_distance.manual
                                                          },
                                                          delta_value: match !== 0 ? ({
                                                                left_value: apr.filters.maps_distance.auto - active_campaign.filters.maps_distance.auto,
                                                                right_value: apr.filters.maps_distance.manual - active_campaign.filters.maps_distance.manual
                                                              }) : undefined
                                                        },
                                                        show_header: false
                                                      }));
                                      })
                                  };
                          }), undefined, undefined),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        };
}

function MandatoryAllocationCampaignsCmp(Props) {
  var filtered_campaings = Props.filtered_campaings;
  var active_and_scheduled_campaign = List.filter(function (campaign) {
          return campaign.campaign_status !== /* PendingForReview */2;
        })(filtered_campaings);
  var active_campaign = Belt_List.getExn(List.filter(function (campaign) {
              return campaign.campaign_status === /* Active */0;
            })(filtered_campaings), 0);
  return React.createElement("div", {
              className: "c-mandatory-campaign-details"
            }, React.createElement("div", {
                  className: "campaign-info"
                }, React.createElement("p", undefined, React.createElement("label", {
                          className: "active-icon"
                        }), "ACTIVE"), React.createElement("p", undefined, React.createElement("label", {
                          className: "scheduled-icon"
                        }), "SCHEDULED")), React.createElement("div", {
                  className: "ald-sidebar-mandatory-campaign-table"
                }, React.createElement("div", {
                      className: "ald-mandatory-table-label"
                    }, React.createElement("p", undefined, "Mandatory")), React.createElement(TableWithRowHover$Catalyst.make, {
                      columns: getTableSchema(active_campaign),
                      row_data: active_and_scheduled_campaign,
                      class_name: "allocation-dashboard-campaign-table"
                    })));
}

var make = MandatoryAllocationCampaignsCmp;

export {
  getTableSchema ,
  make ,
  
}
/* react Not a pure module */
